import FileUpload from "components/FileUpload"
import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { classNames } from "utils/classNames"
import { validate } from "./helper"

const formSchema = {
  firstStep: [
    {
      id: 1,
      name: "firstName",
      type: "text",
      required: true,
      label: "first-name",
      placeholder: "",
    },
    {
      id: 2,
      name: "lastName",
      type: "text",
      required: true,
      label: "last-name",
      placeholder: "",
    },

    {
      id: 132323,
      name: "email",
      type: "email",
      required: true,
      label: "auth-email",
      placeholder: "",
    },
    {
      id: 12333232,
      name: "password",
      type: "password",
      required: true,
      label: "auth-password",
      placeholder: "",
    },
    {
      id: 121219999,
      name: "photo",
      type: "file",
      required: false,
      label: "auth-photo",
    },
  ],
  secondStep: [
    {
      id: 1323123123312323,
      name: "code",
      type: "text",
      required: true,
      label: "auth-code",
      placeholder: "verify-with-email",
    },
  ],
}

const SignUp = ({ actions: { submitForm, step }, fields }) => {
  const formValidator = () => {
    let isValidForm = true
    formSchema[step].forEach((element) => {
      if (
        element.required &&
        validate({ [element?.name]: fields[element?.name]?.value }).errors[
          element?.name
        ]
      ) {
        isValidForm = false
      }
    })
    return isValidForm
  }
  const { t } = useTranslation()
  const [media, setMedia] = useState({})
  const [img, setImg] = useState("")
  const [checkValidate, setCheckValidate] = useState(false)
  const handleForm = () => {
    setCheckValidate(() => true)
    if (formValidator()) {
      submitForm({ ...fields, files: media }, step)
    }
  }
  const imagehandler = (val) => {
    setImg(URL.createObjectURL(val.target.files[0]))
    setMedia(() => val.target.files[0])
  }

  const formCreator = (field) => {
    switch (field.type) {
      case "text":
        return (
          <label className="block mb-4">
            <p className="mb-2 font-semibold leading-normal text-white">
              {t(`${field?.label}`)}
              <span className="mx-2 text-red-500">*</span>
            </p>
            <input
              {...fields[field?.name]}
              className="px-4 py-3.5 w-full text-white font-medium placeholder-gray-400 bg-[rgba(57,57,57,.5)] outline-none border border-[#B3B3B3] rounded-xl  outline-offset-0 focus:border-[rgba(255,255,255,0.8)] focus:bg-gray-700"
              type={field?.type}
              autoComplete="off"
            />
            <p className="h-10 mx-2 text-red-500">
              {checkValidate &&
                t(
                  validate({ [field?.name]: fields[field?.name]?.value })
                    .errors[field?.name]
                )}
            </p>
            <p className="mx-2">{t(field?.placeholder)}</p>
          </label>
        )
      case "email":
        return (
          <label className="block mb-4 ">
            <p className="mb-2 font-semibold leading-normal text-white">
              {t(`${field?.label}`)}
              <span className="mx-2 text-red-500">*</span>
            </p>
            <input
              {...fields[field?.name]}
              className="px-4 py-3.5 w-full text-white font-medium placeholder-gray-400 bg-[rgba(57,57,57,.5)] outline-none border border-[#B3B3B3] rounded-xl  outline-offset-0 focus:border-[rgba(255,255,255,0.8)] focus:bg-gray-700"
              type={field?.type}
              autoComplete="off"
            />
            <p className="h-10 mx-2 text-red-500">
              {t(
                validate({ [field?.name]: fields[field?.name]?.value }).errors[
                  field?.name
                ]
              )}
            </p>
          </label>
        )
      case "password":
        return (
          <>
            {" "}
            <label className="relative block">
              <p className="mb-2 font-semibold leading-normal text-white">
                {t(`${field?.label}`)}
                <span className="mx-2 text-red-500">*</span>
              </p>
              <input
                {...fields[field?.name]}
                className="px-4 py-3.5 w-full text-white font-medium placeholder-gray-400 bg-[rgba(57,57,57,.5)] outline-none border border-[#B3B3B3] rounded-xl  outline-offset-0 focus:border-[rgba(255,255,255,0.8)] focus:bg-gray-700 invalid:border-red-500 invalid:text-red-600 focus:invalid:border-red-500 focus:invalid:ring-red-500"
                type="text"
                autoComplete="new-password"
              />
              {/* <button
                type="button"
                onClick={() => setShowPass((prev) => !prev)}
                className="absolute top-[55%] right-3 text-disabled-text-color"
              >
                {showPass ? (
                  <AiOutlineEye size={24} color={"var(--custom-secondary)"} />
                ) : (
                  <AiOutlineEyeInvisible size={24} />
                )}
              </button> */}
            </label>
            <p className="h-10 mx-2 text-red-500">
              {t(
                validate({ [field?.name]: fields[field?.name]?.value }).errors[
                  field?.name
                ]
              )}
            </p>
          </>
        )
      case "file":
        return (
          <div className="flex items-center justify-between w-full gap-4">
            <label className="block w-full h-full transition-all duration-200">
              <p className="mb-2 font-semibold leading-normal text-white">
                {t(`${field?.label}`)}
              </p>
              <FileUpload onChange={imagehandler} />
            </label>
            {img && (
              <img
                className="transition-all duration-200 rounded-full w-36 h-36"
                src={img}
                alt="avatar_img"
              />
            )}
          </div>
        )
    }
  }

  return (
    <div className="flex flex-col justify-center p-10 lg:p-16 md:p-10 sm:p-10 xxl:p-24">
      <h4 className="mb-6 text-xl font-medium text-center">
        {t("auth-register")}
      </h4>
      <form className="w-full mx-auto" autoComplete="off">
        <div className="block w-full grid-cols-1 mx-auto md:grid md:grid-cols-2 gap-x-4">
          {formSchema[step].map((field) => {
            return (
              <div
                className={classNames(
                  (field.type === "file" || field?.name === "code") &&
                    "col-span-1 md:col-span-2"
                )}
                key={field.id}
              >
                {formCreator(field)}
              </div>
            )
          })}
        </div>
        <div className="flex items-center justify-between gap-4">
          <button
            disabled={!formValidator()}
            className={classNames(
              !formValidator() ? "cursor-not-allowed" : "",
              "w-full py-4 pt-5 font-semibold text-white transition duration-200 ease-in-out border px-9 rounded-xl shadow-4xl hover:bg-gray-700"
            )}
            type="button"
            onClick={handleForm}
          >
            {t("auth-send-btn")}
          </button>
        </div>
      </form>
    </div>
  )
}

export default SignUp
